import { render, staticRenderFns } from "./HouseItem.vue?vue&type=template&id=1a08f8f7"
import script from "./HouseItem.vue?vue&type=script&lang=js"
export * from "./HouseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports